import React, { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ProgramCard from "../Programs/ProgramCard";
import { fetchProgramList, fetchProgramById, fetchProgramImageById } from "../redux/actions/Actions";

const CourseDetailTemplate = ({
  title, description, curriculum, structure, tags,
  programName,
}) => {
  const navigate        = useNavigate();
  const dispatch        = useDispatch();
  const reduxAuth = useSelector((s) => s.auth.isAuthenticated);
  const fetchPrograms = useSelector((s) => s.fetchAllPrograms.programs);
  const programCourses = useSelector((s) => s.fectchProgramById.programById);
  const programImage = useSelector((s) => s.fetchProgramImageById.programImageById);

  const getLocalUser = () => {
    try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
  };
  const isAuthenticated = reduxAuth || !!getLocalUser()?.email;

  useEffect(() => { dispatch(fetchProgramList()); }, [dispatch]);

  const courseData = fetchPrograms.find((p) => p.program_name === programName);

  useEffect(() => {
    if (courseData?.program_id) {
      dispatch(fetchProgramById(courseData.program_id));
      dispatch(fetchProgramImageById(courseData.program_id));
    }
  }, [dispatch, courseData?.program_id]);

  const brochureCourse = programCourses
    ?.filter((c) => c.program_id === courseData?.program_id)
    .sort((a, b) => a.course_id - b.course_id)[0];
  const brochureHref     = programImage?.brochure_url || brochureCourse?.pdf_file_path;
  const brochureFilename = brochureHref ? `${programName}.pdf` : undefined;

  const triggerDownload = (href, filename) => {
    const link      = document.createElement("a");
    link.href       = href;
    link.download   = filename;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    setTimeout(() => document.body.removeChild(link), 100);
  };

  const brochureDownload = () => {
    const localUser = getLocalUser();
    const loggedIn  = reduxAuth || !!localUser?.email;
    if (!loggedIn) {
      navigate("/registerform", { state: { brochureHref, brochureFilename } });
      return;
    }
    triggerDownload(brochureHref, brochureFilename);
  };

  return (
    <div style={{ fontFamily: "'Inter','Segoe UI',sans-serif", background: "#F8FAFC" }}>
      <style>{`
        @media (max-width: 900px) {
          .cdt-hero-stats { flex-direction: column !important; gap: 16px !important; padding: 20px !important; }
          .cdt-steps-grid { grid-template-columns: repeat(2,1fr) !important; }
        }
        @media (max-width: 600px) {
          .cdt-curriculum-grid { grid-template-columns: 1fr !important; }
          .cdt-steps-grid      { grid-template-columns: 1fr !important; }
          .cdt-btn             { min-width: 0 !important; width: 100% !important; }
        }
      `}</style>

      {/* ── Hero ── */}
      <div style={s.hero}>
        <div style={{ ...s.ring, width: 520, height: 520, top: -180, right: -160, opacity: 0.08 }} />
        <div style={{ ...s.ring, width: 300, height: 300, bottom: -80, left: -80,  opacity: 0.06 }} />

        <div style={s.heroInner}>
          <div style={s.topLabel}>
            <span style={s.chevron}>‹</span>
            UPLSNIPE &nbsp;|&nbsp; {title.toUpperCase()}
            <span style={s.chevron}>›</span>
          </div>

          <h1 style={s.heroTitle}>{title}</h1>
          <p style={s.heroDesc}>{description}</p>

          {tags?.length > 0 && (
            <div style={s.heroTags}>
              {tags.map((t) => <span key={t} style={s.tag}>{t}</span>)}
            </div>
          )}

          <div style={s.heroBtns}>
            {!brochureHref ? null : (reduxAuth || !!getLocalUser()?.email) ? (
              <a
                href={brochureHref}
                download={brochureFilename}
                target="_blank"
                rel="noreferrer"
                className="cdt-btn"
                style={{ ...s.btnPrimary, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                onMouseEnter={e => e.currentTarget.style.background = '#1E40AF'}
                onMouseLeave={e => e.currentTarget.style.background = '#1E3A8A'}
              >
                Download Brochure
              </a>
            ) : (
              <button className="cdt-btn" style={s.btnPrimary} onClick={brochureDownload}
                onMouseEnter={e => e.currentTarget.style.background = '#1E40AF'}
                onMouseLeave={e => e.currentTarget.style.background = '#1E3A8A'}>
                Download Brochure
              </button>
            )}
            <Link to="/request-callback" className="cdt-btn" style={s.btnOutline}
              onMouseEnter={e => e.currentTarget.style.opacity = '0.88'}
              onMouseLeave={e => e.currentTarget.style.opacity = '1'}>
              Talk to an Advisor
            </Link>
          </div>

          <div className="cdt-hero-stats" style={s.heroStats}>
            {[{ v: structure.length + " Steps", l: "Program" }, { v: curriculum.length + "+", l: "Topics" }, { v: "100%", l: "Placement Support" }].map((st) => (
              <div key={st.l} style={s.heroStat}>
                <div style={s.heroStatV}>{st.v}</div>
                <div style={s.heroStatL}>{st.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Content ── */}
      <div style={s.content}>

        {/* Curriculum */}
        <div style={s.section}>
          <div style={s.sectionHeader}>
            <span style={s.eyebrow}>CURRICULUM</span>
            <h2 style={s.sectionTitle}>Course Description</h2>
            <p style={s.sectionSub}>A structured path from fundamentals to real-world deployment.</p>
          </div>
          <div className="cdt-curriculum-grid" style={s.curriculumGrid}>
            {curriculum.map((item, i) => (
              <div key={i} style={s.curriculumItem}>
                <div style={s.checkIcon}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563EB" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <span style={s.curriculumText}>{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Structure */}
        <div style={{ ...s.section, paddingTop: 56 }}>
          <div style={s.sectionHeader}>
            <span style={s.eyebrow}>PROGRAM STRUCTURE</span>
            <h2 style={s.sectionTitle}>Your Learning Journey</h2>
            <p style={s.sectionSub}>Clear phases from enrollment to placement.</p>
          </div>
          <div className="cdt-steps-grid" style={s.stepsGrid}>
            {structure.map((st, i) => (
              <div key={i} style={s.stepCard}>
                <div style={s.stepNum}>0{i + 1}</div>
                <div style={s.stepTitle}>{st.title}</div>
                <div style={s.stepDesc}>{st.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Enroll */}
        {courseData && (
          <div style={s.section}>
            <div style={s.sectionHeader}>
              <span style={s.eyebrow}>PRICING</span>
              <h2 style={s.sectionTitle}>Enroll Today</h2>
            </div>
            <ProgramCard data={[courseData]} />
          </div>
        )}

        {/* CTA */}
        <div style={s.ctaBanner}>
          <h3 style={s.ctaTitle}>Explore More Programs</h3>
          <p style={s.ctaDesc}>UPL bootcamp includes dynamic career-transforming programs across multiple domains.</p>
          <Link to="/programs" style={s.ctaBtn}
            onMouseEnter={e => e.currentTarget.style.background = '#1D4ED8'}
            onMouseLeave={e => e.currentTarget.style.background = '#2563EB'}>
            View All Programs →
          </Link>
        </div>
      </div>
    </div>
  );
};

export const s = {
  hero: {
    position: "relative", overflow: "hidden",
    background: "linear-gradient(180deg,#0D9488 0%,#0EA5E9 28%,#2563EB 58%,#1D4ED8 100%)",
    padding: "64px 5% 72px", textAlign: "center",
  },
  ring: { position: "absolute", borderRadius: "50%", border: "1.5px solid #fff", pointerEvents: "none" },
  heroInner: { position: "relative", zIndex: 1, maxWidth: 760, margin: "0 auto" },
  topLabel: {
    fontSize: 11, fontWeight: 700, letterSpacing: "0.14em",
    color: "rgba(255,255,255,0.7)", textTransform: "uppercase",
    marginBottom: 20, display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
  },
  chevron:   { opacity: 0.5, fontSize: 13 },
  heroTitle: { fontSize: "clamp(32px,5vw,60px)", fontWeight: 900, color: "#fff", letterSpacing: "-0.03em", lineHeight: 1.1, margin: "0 0 20px" },
  heroDesc:  { fontSize: 16, color: "rgba(255,255,255,0.82)", lineHeight: 1.75, maxWidth: 620, margin: "0 auto 24px" },
  heroTags:  { display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center", marginBottom: 32 },
  tag: {
    background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.25)",
    borderRadius: 20, padding: "5px 14px", fontSize: 12, fontWeight: 600, color: "#fff", backdropFilter: "blur(4px)",
  },
  heroBtns: { display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap", marginBottom: 40 },
  btnPrimary: {
    padding: "14px 48px", background: "#1D4ED8", color: "#fff",
    border: "2px solid #1D4ED8", borderRadius: 4,
    fontSize: 13, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
    cursor: "pointer", transition: "background 0.2s", minWidth: 220,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
  },
  btnOutline: {
    padding: "14px 48px", background: "#fff", color: "#0F172A",
    border: "2px solid #fff", borderRadius: 4,
    fontSize: 13, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
    textDecoration: "none", transition: "opacity 0.2s", minWidth: 220,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
  },
  heroStats: {
    display: "flex", gap: 0, justifyContent: "center",
    background: "rgba(255,255,255,0.12)", border: "1px solid rgba(255,255,255,0.2)",
    borderRadius: 14, padding: "16px 40px", backdropFilter: "blur(8px)",
    maxWidth: 480, margin: "0 auto",
  },
  heroStat:  { flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 },
  heroStatV: { fontSize: 22, fontWeight: 800, color: "#fff", letterSpacing: "-0.02em" },
  heroStatL: { fontSize: 11, color: "rgba(255,255,255,0.65)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" },

  content: { maxWidth: 1100, margin: "0 auto", padding: "0 5% 80px" },
  section: { paddingTop: 64 },
  sectionHeader: { textAlign: "center", marginBottom: 40 },
  eyebrow: {
    display: "inline-block", fontSize: 11, fontWeight: 800, letterSpacing: "0.14em",
    color: "#2563EB", background: "#EFF6FF", padding: "4px 14px", borderRadius: 20,
    marginBottom: 12, textTransform: "uppercase",
  },
  sectionTitle: { fontSize: "clamp(22px,3vw,34px)", fontWeight: 800, color: "#0F172A", letterSpacing: "-0.02em", margin: "0 0 10px" },
  sectionSub:   { fontSize: 15, color: "#64748B", lineHeight: 1.65, margin: 0 },

  curriculumGrid: { display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 14, maxWidth: 860, margin: "0 auto" },
  curriculumItem: {
    display: "flex", alignItems: "flex-start", gap: 12,
    background: "#fff", border: "1px solid #E2E8F0", borderRadius: 10,
    padding: "14px 18px", boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
  },
  checkIcon: {
    width: 26, height: 26, borderRadius: "50%", background: "#EFF6FF", border: "1px solid #BFDBFE",
    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
  },
  curriculumText: { fontSize: 14, color: "#334155", fontWeight: 500, lineHeight: 1.55 },

  stepsGrid: { display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 20, maxWidth: 900, margin: "0 auto" },
  stepCard:  {
    background: "#fff", border: "1px solid #E2E8F0", borderRadius: 14,
    padding: "24px 22px", boxShadow: "0 2px 8px rgba(37,99,235,0.06)",
  },
  stepNum:   { fontSize: 11, fontWeight: 800, color: "#2563EB", letterSpacing: "0.1em", marginBottom: 10, fontFamily: "monospace" },
  stepTitle: { fontSize: 15, fontWeight: 700, color: "#0F172A", marginBottom: 8 },
  stepDesc:  { fontSize: 13, color: "#64748B", lineHeight: 1.6 },

  ctaBanner: {
    marginTop: 64, textAlign: "center",
    background: "linear-gradient(135deg,#0D9488 0%,#0EA5E9 50%,#2563EB 100%)",
    borderRadius: 20, padding: "52px 5%",
  },
  ctaTitle: { fontSize: "clamp(20px,3vw,30px)", fontWeight: 800, color: "#fff", margin: "0 0 12px" },
  ctaDesc:  { fontSize: 15, color: "rgba(255,255,255,0.82)", marginBottom: 28 },
  ctaBtn: {
    display: "inline-block", padding: "14px 36px", background: "#2563EB", color: "#fff",
    textDecoration: "none", borderRadius: 10, fontWeight: 700, fontSize: 14,
    transition: "background 0.2s", letterSpacing: "0.04em",
  },
};

export default CourseDetailTemplate;
